import { Component, OnInit, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass, DecimalPipe } from '@angular/common';

import { TranslateDirective } from '@speedy/core';

import { CurrencyComponent } from '../../../../../../shared/components/currency/currency.component';
import { CalculatorService } from '../../../services/calculator.service';

@Component({
  selector: 'app-tfbank-calculator',
  templateUrl: './tfbank-calculator.component.html',
  styleUrls: ['./tfbank-calculator.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    TranslateDirective,
    ReactiveFormsModule,
    FormsModule,
    CurrencyComponent,
    MatProgressSpinner,
    DecimalPipe,
  ],
})
export class TfbankCalculatorComponent implements OnInit {
  @Input() productPrice!: number;

  leasePeriod = 6;
  leasePeriods = [6, 12, 18, 24, 30, 36, 42, 48, 53, 60];
  monthlyPayment!: number;

  loadingPayment = false;

  partnerInterestRate = 7.9;
  partnerOpeningFee = 0;
  partnerMonthlyCost = 0.99;

  constructor(protected calculatorService: CalculatorService) {}

  ngOnInit() {
    this.calculateLease();

    /** TODO: campain configuration */
    // if (this.today.isSameOrBefore(this.campaignEndDate, 'date')) {
    //   this.partnerInterestRate = 0;
    //   this.partnerMonthlyCost = 0;
    //   this.partnerOpeningFee = 0;
    // }
  }

  calculateLease() {
    this.loadingPayment = true;

    const months = this.leasePeriod;
    const productPrice = this.productPrice;
    const partnerInterestRate = this.partnerInterestRate;

    const partnerOpeningFee = this.partnerOpeningFee;
    const partnerMonthlyCost = this.partnerMonthlyCost;

    this.monthlyPayment =
      (productPrice * (partnerInterestRate / 100)) / 12 +
      (productPrice + partnerOpeningFee) / months +
      partnerMonthlyCost;

    this.loadingPayment = false;
  }
}
